// Module
var code = "<div id=\"file-zip-download-dialog\" fs-confirm-dialog ok-callback=\"downloadZip()\" ok-button-text=\"Download\"> <div> <span id=\"file-zip-download-message\">This will generate {{numberOfZipFiles}} zip files, one per owner. Would you like to continue?</span> </div> </div>";
// Exports
module.exports = code;